import { request } from "../api";

export const listSuppliers = params => request.get("/suppliers", params);
export const getSupplier = id => request.get(`/suppliers/${id}`);
export const createSupplier = body => request.post("/suppliers", body);
export const updateSupplier = (id, body) => request.put(`/suppliers/${id}`, body);
export const deactivateSupplier = id => request.del(`/suppliers/${id}`);
export const getBelegeMeta = () => request.get("/belege/meta");
